export enum SomnologyOrganizationType {
    ksyosMedicalCenter = 'ksyosMedicalCenter',
    nsi = 'nsi',
}
